import { ApiFunctionType, httpPostCancellable } from 'src/utils/http';

export const apiDismissLivestreamBanner: ApiFunctionType<
  { CampaignPermanentUrl: string },
  { LivestreamBannerIsVisible: boolean }
> = httpPostCancellable('/campaignUserPreferences/dismissLiveStreamReminder');

export const apiToggleEventManagementQuickLinksCollapsed: ApiFunctionType<
  {
    campaignPermanentUrl: string;
    AreCollapsed: boolean;
  },
  unknown
> = httpPostCancellable('/campaignUserPreferences/SaveEventManagementQuickLinksCollapsed');
